import { createEntityAdapter, createSelector, createSlice, EntitySelectors } from '@reduxjs/toolkit';
import { ExternalUploaderSettings } from '@ff-os/shared-json/ExternalUploaderSettings';
import { loadExternalUploaders } from '../apis/external-upload/loadExternalUploaders';
import { PdpState } from '../store';

const adapter = createEntityAdapter<ExternalUploader<any>>();

const additionalState: { status: ExternalUploadStatus } = { status: 'ready' };

export const { actions, reducer } = createSlice({

    name: 'externalUpload',
    initialState: adapter.getInitialState(additionalState),
    reducers: {
        add: adapter.addOne,
        updateImageCount: (state, action) => {
            for (const asset of action.payload) {
                const externalUploader = state.entities[asset.externalUploaderId];
                if (externalUploader) {
                    externalUploader.imageCount += 1;
                }
            }
        }
    },

    extraReducers: builder => {

        builder.addCase(loadExternalUploaders.pending, (state, action) => {
            state.status = 'pending';
        });

        builder.addCase(loadExternalUploaders.fulfilled, (state, action) => {

            const entries = action.payload.entries.map(e => ({ ...e, imageCount: 0 }));

            state.status = 'ready';
            adapter.setAll(state, entries);
        });
    }
});

export type ExternalUploadStatus = 'ready' | 'pending';

export type ExternalUploader<TPayload> = {
    id: string;
    url: string;
    imageCount: number;
    createdOn: number;
    expiresOn: number;
    settings: ExternalUploaderSettings<TPayload>;
};

export const createSelectorBindings = <TPayload>(): EntitySelectors<ExternalUploader<TPayload>, PdpState> =>
    adapter.getSelectors<PdpState>(s => s.externalUploaders);

export const selectExternalUploadStatus = createSelector([
    (state: PdpState) => state.externalUploaders.status
], status => status);